function Home() {
  return (
    <div>
      <h1>Welcome to Shamlin's Quote Sanctuary ✨</h1>
      <p>
        I connect with people, reflect on life’s rhythms, and collect the
        lessons it whispers.
      </p>
    </div>
  );
}

export default Home;
